<div id="wrap" class="moWrap m_event_wrap event_250415">
  <header class="header">
      <div class="header_inner">
          <h1 class="header_logo">
              <a href="" class="logo"><img src="/assets/images/web/logo/logo_348.png" alt="OASIS BUDDY" /></a>
          </h1>
          <span class="util_right">
              <a href="https://www.oasis.co.kr" target="_blank" class="btn_oasis ico_blank">오아시스마켓</a>
          </span>
      </div>
  </header>

  <div class="tabsMenuConts">
      <div class="tabConts">
          <!-- content1 -->
          <div class="conts cont1 tabUse" id="oAnchorCont1">
              <h2><img src="https://oasisprodcom.edge.naverncp.com/buddy/event/event_250415/mobile/img_cont1.jpg" /></h2>
              <div class="blind">
                  <strong>OASIS BUDDY</strong>
                  <p>유기농 먹거리로 장보고, 리워드 수익도 받고!</p>
                  <p>나만의 식품 컨텐츠를 만들어 SNS에 공유하고 공유한 링크로 구매가 발생하면 수익으로 돌려드려요!</p>
              </div>
              <div class="evBtn_flexBox">
                <a (click)="moveJoin()"><span class="blind">버디 가입하기</span></a>
              </div>
          </div>
          <!-- //content1 -->
          <!-- content2 -->
          <div class="conts cont2" id="oAnchorCont2">
            <h2>
              <img src="https://oasisprodcom.edge.naverncp.com/buddy/event/event_250415/mobile/img_cont2_1.jpg" />
              <img src="https://oasisprodcom.edge.naverncp.com/buddy/event/event_250415/mobile/img_cont2_2.jpg" />
            </h2>
            <div class="blind">
                <strong>리워드 수익 받는 방법</strong>
                <ol>
                  <li>1. 오아시스 버디 가입하기</li>
                  <li>2. 원하는 링크를 버디 전용 링크로 생성하기</li>
                  <li>3. 내 SNS에 생성한 버디링크 공유하기(*블로그, 인스타그램, 유튜브 등)</li>
                  <li>4. 버디링크로 인해 발생한 구매금액의 리워드</li>
                </ol>
                <p>등급에 관계없이 오아시스버디라면 누구나! 구매 금액의 20%를 리워드 받으실 수 있습니다.</p>
            </div>
          </div>
          <!-- //content2 -->
          <!-- content3 -->
          <div class="conts cont3" id="oAnchorCont3">
              <h2><img src="https://oasisprodcom.edge.naverncp.com/buddy/event/event_250415/mobile/img_cont3.jpg"></h2>
              <div class="blind">
                <strong>오아시스버디만의 혜택</strong>
                <ul>
                  <li>수수료 20% 업계 최고 수준! 버디 등급 관계없이 20% 지급</li>
                  <li>익월 정산 시스템. 더 빠르고 편리한 정산&지급 혜택 제공</li>
                  <li>기여도에 따른 별도 계약 가능. 다양한 광고 매칭 및 월 고정급여 제공</li>
                  <li>채널 및 컨텐츠 홍보. 마케팅 및 판매 등 지속적인 지원 제공</li>
                </ul>
              </div>
          </div>
          <!-- //content3 -->
          <!-- content4 -->
          <div class="conts cont4" id="oAnchorCont4">
              <h2><img src="https://oasisprodcom.edge.naverncp.com/buddy/event/event_250415/mobile/img_cont4.jpg" alt="유의사항" /></h2>
          </div>
          <!-- //content4 -->
      </div>
  </div>

  <footer class="footer">
      <div class="footer_inner">
          <div class="footer_menu">
              <a routerLink="/guide">이용가이드</a>
              <a href="https://www.oasis.co.kr/help/privacy" target="_blank" title="새창" class="emphasis">개인정보처리방침</a>
              <a routerLink="/terms">약관 및 정책</a>
          </div>
      </div>
  </footer>
</div>
